import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-letters-speakers-preview-dialog',
  templateUrl: './letters-speakers-preview-dialog.component.html',
  styleUrls: ['./letters-speakers-preview-dialog.component.scss']
})
export class LettersSpeakersPreviewDialogComponent implements OnInit {

  public letter: any;
  public event: any;
  public letter_preview: any;

  constructor (
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.letter = this.data.letter;
    this.event = this.data.event;
  }

  ngOnInit () {
    this.letter_preview = this.makeEmail(this.letter);
  }


  makeEmail (letter: any) {

    let link_resposta = ""
    link_resposta += "<a href=''>";
    link_resposta += "<span style='color:blue; cursor:pointer;'>Clique aqui para registrar sua resposta e revisar seus dados.</span>";
    link_resposta += "</a>";

    let resumo_atividade: string = this.getActivity();

    // realiza as substituições das tgs pelos seus valores reais
    let temp_text = letter.text;

    if (letter.imageTop) {
      temp_text = temp_text.replace('[imagem_1]', "<img src='" + letter.imageTop + "'>")
    }
    else {
      temp_text = temp_text.replace('[imagem_1]', "")
    }

    if (letter.imageBottom) {
      temp_text = temp_text.replace('[imagem_2]', "<img src='" + letter.imageBottom + "'>")
    } else {
      temp_text = temp_text.replace('[imagem_2]', "")
    }

    if (letter.imageBody) {
      temp_text = temp_text.replace('[imagem_corpo]', "<img src='" + letter.imageBody + "'>")
    } else {
      temp_text = temp_text.replace('[imagem_corpo]', "")
    }

    temp_text = temp_text.replace('[nome_associado]', "Antonio Carlos")
    temp_text = temp_text.replace('[link_resposta]', link_resposta)
    temp_text = temp_text.replace('[resumo_atividade]', resumo_atividade)

    return "<div>" + temp_text + "</div>";
  }

  getActivity () {
    let resumo_atividade: string = ""

    resumo_atividade += "<ul>";

    resumo_atividade += "<div>";
    resumo_atividade += "<span>" + "Coordenador" + "</span>";
    resumo_atividade += "<span> na atividade</span>";
    resumo_atividade += "</div>";

    resumo_atividade += "<li>";
    resumo_atividade += "<div>Data: </div>";
    resumo_atividade += "<div>" + "01/01/2000" + "</div>";
    resumo_atividade += "</li>";

    resumo_atividade += "<li>";
    resumo_atividade += "<div>Atividade: </div>";
    resumo_atividade += "<div>" + "08:00" + " - " + "Atividade" + "</div>";
    resumo_atividade += "</li>";


    resumo_atividade += "<ul>";
    resumo_atividade += "<div>Equipe da atividade</div>";

    resumo_atividade += "Coordenador" + " - " + "<span style='color:rgb(0,0,220);'>" + "Antonio Carlos" + "</span>";

    resumo_atividade += "</li>";

    resumo_atividade += "</ul>";

    resumo_atividade += "<hr>";

    resumo_atividade += "<ul>";

    resumo_atividade += "<li>";
    resumo_atividade += "08:00" + " - " + "Tópico Um";
    resumo_atividade += "</li>";

    resumo_atividade += "<li>";
    resumo_atividade += "09:00" + " - " + "Tópico Dois";
    resumo_atividade += "</li>";

    resumo_atividade += "</ul>";

    resumo_atividade += "</ul>";

    return resumo_atividade;
  }
}